import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { UpdateTransactionProduct } from 'app/dtos/TransactionProduct/updateTransactionProduct';
import { AuthService } from 'app/services/auth.service';
import { CurrencyService } from 'app/services/models/currency.service';
import { TaxService } from 'app/services/models/tax.service';
import { TransactionAdditionalFeatureService } from 'app/services/models/transaction-additional-feature.service';
import { TransactionProductDescriptionService } from 'app/services/models/transaction-product-description.service';
import { TransactionProductService } from 'app/services/models/transaction-product.service';
import { TransactionService } from 'app/services/models/transaction.service';
import { WarehouseService } from 'app/services/models/warehouse.service';
import { ToastrService } from 'ngx-toastr';

@Component({
  selector: 'app-transaction-update-dialog',
  templateUrl: './transaction-update-dialog.component.html',
  styleUrls: ['./transaction-update-dialog.component.scss']
})
export class TransactionUpdateDialogComponent implements OnInit {
  @Input() data;
  transactionProduct: any = {};
  allTax: any[] = [];
  selectedWarehouseId: number;
  total: number = 0;
  currencies: any[] = [];
  selectedCurrencyId: number;
  warehouses: any[] = [];

  descriptionList: string[] = [];
  selectedSerialIds: number[] = [];

  constructor(
    public ngbModal: NgbActiveModal,
    private transactionService: TransactionService,
    private transactionProductService: TransactionProductService,
    private taxService: TaxService,
    private currencyService: CurrencyService,
    private transacitonProductDescriptionService: TransactionProductDescriptionService,
    private toastrService: ToastrService,
    private warehouseService: WarehouseService,
    public authService: AuthService,
    private transactionFeatureService: TransactionAdditionalFeatureService) { }

  features: any[] = [];
  selectedFeatures: any[] = [];

  async ngOnInit() {
    await this.getAllTransactionFeatures();
    await this.getAllTax();
    await this.getAllCurrency();
    await this.getAllWarehouse();
    await this.getByIdTransactionProduct(this.data);
  }

  async getAllTransactionFeatures() {
    const data = await this.transactionFeatureService.getAllTransactionAdditionalFeatures(0, 1000, null);
    console.log(data);
    this.features = data.transactionAdditionals.map(feature => ({
      ...feature,
      value: feature.value ?? false // Eğer değer yoksa varsayılan olarak false ata
    }));
  }

  updateSelectedFeatures() {
    this.selectedFeatures = this.features.map(feature => {
      return {
        id: feature.id,
        transactionAdditionalFeatureId: feature.id, // Doğru ID eşleştirmesi
        name: feature.name,
        value: feature.value == 'true' ? true:false // Direkt olarak güncellenen değeri ata
      };
    });
    console.log('Updated Selected Features:', this.selectedFeatures);
  }

  async getAllWarehouse() {
    const data = await this.warehouseService.getAllWarehouses(0, 100, '');
    console.log(data);
    this.warehouses = data.warehouses;
  }

  getProductCountDifference(warehouseId: number): number {
    const productCount = this.transactionProduct.transactionProductsCount.find(pc => pc.warehouseId === warehouseId);
    return productCount ? productCount.productCountDifference : 0;
  }


  async getAllCurrency() {
    const data = await this.currencyService.getAllPageCurrency(0, 100, '');
    this.currencies = data.currenies;
  }

  onCurrencySelect(event: any) {
    const selectedValue = event.target.value;
    console.log("Seçilen para:", selectedValue);
    this.selectedCurrencyId = selectedValue;
  }

  async getByIdTransactionProduct(id) {
    const data = await this.transactionProductService.transactionProductById(id);
    this.transactionProduct = data;
    console.log(this.transactionProduct);
    this.descriptionList = data.transactionProductDescriptions.map(desc => desc.description);
    this.selectedSerialIds = data.transactionProductSerialNos.map(
      (serial) => serial.productSerialId
    );
    this.calculateTotalPrice();
    this.selectedWarehouseId = this.transactionProduct.warehouseId;
    this.selectedCurrencyId = this.transactionProduct.currencyId;
    this.allFieldsFilled();
    if (this.transactionProduct.transactionAdditionalFeatureMatchings) {
      console.log("Transaction Additional Features:", this.transactionProduct.transactionAdditionalFeatureMatchings);
      console.log(this.features);

      // 1️⃣ Features dizisini güncelle
      this.features.forEach(feature => {
        const matchedFeature = this.transactionProduct.transactionAdditionalFeatureMatchings.find(
          af => af.transactionAdditionalFeatureId === feature.id
        );
        if (matchedFeature) {
          feature.value = matchedFeature.value; // Eşleşen varsa değeri ata
        }
      });

      // 2️⃣ Güncellenmiş feature değerlerini seçili listeye aktar
      this.selectedFeatures = this.transactionProduct.transactionAdditionalFeatureMatchings.map(matching => {
        // Features içinde eşleşen özelliği bul
        const feature = this.features.find(f => f.id === matching.transactionAdditionalFeatureId);
        return {
          id: matching.id, // Transaction Additional Feature ID
          transactionAdditionalFeatureId: matching.transactionAdditionalFeatureId, // Doğru ID kullanıldı
          name: feature ? feature.name : "Bilinmeyen Özellik",
          value: matching.value
        };
      });

      console.log("Updated Features:", this.features);
      console.log("Selected Features:", this.selectedFeatures);
    }
  }

  addDescription() {
    if (!this.transactionProduct.transactionProductDescriptions) {
      this.transactionProduct.transactionProductDescriptions = [];
    }
    this.transactionProduct.transactionProductDescriptions.push({
      description: ''
    });
  }

  async removeDescription(index: number) {
    if (this.transactionProduct.transactionProductDescriptions && this.transactionProduct.transactionProductDescriptions.length > index) {
      // İlgili açıklamanın id'sini al
      const descriptionId = this.transactionProduct.transactionProductDescriptions[index]?.id;

      if (descriptionId) {
        console.log("Silinecek Açıklamanın ID'si:", descriptionId);
        const data = await this.transacitonProductDescriptionService.removeTransactionProductService(descriptionId);
        if (data.status == true) {
          this.toastrService.success(data.message);
          this.closeModal();
        } else {
          this.toastrService.error(data.message);
        }
      }
    }
  }

  onSaleTaxChange(event: any) {
    // Seçilen KDV ID'sini al
    const selectedTaxId = Number(event.target.value);


    // allTax dizisinde seçilen KDV'yi bul
    const selectedTax = this.allTax.find(tax => tax.id === selectedTaxId);


    // Seçilen KDV varsa, güncelle
    if (selectedTax) {
      this.transactionProduct.taxId = selectedTax.id;

    } else {
      this.transactionProduct.saleTax = null;
    }

    // Toplam fiyatı hesapla
    this.calculateTotalPrice();
  }


  async getAllTax() {
    const data = await this.taxService.getAllTax(0, 100, '');
    console.log(data);
    this.allTax = data.taxex;
  }

  closeModal() {
    this.ngbModal.close();
  }

  onWarehouseChange(event: any) {
    this.selectedWarehouseId = event?.target.value;
    console.log("Seçilen Depo ID:", this.selectedWarehouseId);
  }

  calculateTotalPrice() {
    const salePrice = this.transactionProduct.productPrice || 0;
    const discountRate = this.transactionProduct.discountRate || 0;
    const taxRate = this.transactionProduct.taxRate || 0;

    const discountedPrice = salePrice - (salePrice * discountRate) / 100;
    const totalWithTax = discountedPrice + (discountedPrice * taxRate) / 100;

    this.total = parseFloat(((this.transactionProduct.productCount || 0) * totalWithTax).toFixed(2));
  }

  calculateSalePriceFromTotal() {
    const discountRate = this.transactionProduct.discountRate || 0;
    const taxRate = this.transactionProduct.saleTax || 0;

    const totalWithoutTax = this.total / (1 + taxRate / 100);
    const salePrice = totalWithoutTax / (1 - discountRate / 100);

    this.transactionProduct.productPrice = (salePrice / this.transactionProduct.productCount).toFixed(2);
    console.log("Satış fiyatı : ", this.transactionProduct.productPrice);
  }

  allFieldsFilled() {
    return (
      this.transactionProduct.productCount != null &&
      this.transactionProduct.productCount > 0 &&
      this.selectedWarehouseId != null &&
      this.transactionProduct.productPrice != null &&
      this.transactionProduct.productPrice > 0 &&
      this.selectedCurrencyId != null &&
      this.transactionProduct.taxId != null
    );
  }

  async updateTransactionProduct() {

    if (this.allFieldsFilled()) {
      const updateTransactionProduct: UpdateTransactionProduct = {
        id: this.transactionProduct.id,
        productId: this.transactionProduct.productId,
        warehouseId: this.selectedWarehouseId,
        productCount: this.transactionProduct.productCount,
        productPrice: this.transactionProduct.productPrice,
        taxId: this.transactionProduct.taxId,
        discountRate: this.transactionProduct.discountRate,
        currencyId: this.selectedCurrencyId,
        descriptions: this.transactionProduct.transactionProductDescriptions.map(desc => ({
          id: desc.id, // Eğer `id` varsa, yoksa undefined olabilir
          description: desc.description
        })),
        serialNos: this.selectedSerialIds,
        updateTransactionAdditionalFeatureMatchings: this.selectedFeatures.map(feature => ({
          isPrivate: true, // Değeri ihtiyaca göre belirleyin
          transactionAdditionalFeatureId: feature.id, // Özellik ID'si
          transactionProductId: this.transactionProduct.id, // Mevcut ürünün ID'si
          value: feature.value // Özelliğin değeri
        }))
      };

      console.log(updateTransactionProduct);

      const data = await this.transactionProductService.updateTransactionProduct(updateTransactionProduct)
      console.log(data);
      if (data.status == true) {
        this.toastrService.success(data.message);
        this.transactionService.sendEvent(true);
        this.closeModal();
      } else {
        this.toastrService.error(data.message);
      }

    } else {
      console.log("Bazı alanlar eksik, güncelleme yapılamaz.");
    }
  }


  isSerialChecked(serialId: number): boolean {
    return this.transactionProduct.transactionProductSerialNos.some(
      (serial) => serial.productSerialId === serialId
    );
  }

  onCheckboxChange(serialId: number, event: any): void {
    if (event.target.checked) {
      // Seçili serialId'yi listeye ekle
      this.selectedSerialIds.push(serialId);
      this.transactionProduct.transactionProductSerialNos.push({
        id: this.transactionProduct.transactionProductSerialNos.length + 1,
        productSerialId: serialId,
        serialNo: this.transactionProduct.productSerials.find(
          (serial) => serial.id === serialId
        )?.serialNo || ''
      });
    } else {
      // Seçili serialId'yi listeden kaldır
      this.selectedSerialIds = this.selectedSerialIds.filter(
        (id) => id !== serialId
      );
      this.transactionProduct.transactionProductSerialNos = this.transactionProduct.transactionProductSerialNos.filter(
        (serial) => serial.productSerialId !== serialId
      );
    }

    // Console'a seçili seri numaralarının ID'lerini yazdır
    this.transactionProduct.productCount = this.selectedSerialIds.length;
    this.calculateTotalPrice();
    this.allFieldsFilled()
    console.log('Seçili Seri ID\'leri:', this.selectedSerialIds);
  }
}
